/* refyglamicblend — behaviour layer (no dependencies, ~4KB) */
(function () {
  'use strict';
  /* UI strings: English defaults; the Arabic storefront sets window.refyT (layout/theme.liquid) */
  function rT(k, d) { return (window.refyT && window.refyT[k]) || d; }
  var mqDesktop = window.matchMedia('(min-width: 990px)');

  /* 1. Mega menu opens on hover (desktop), keeps Dawn's click/keyboard behaviour */
  function initMegaHover() {
    document.querySelectorAll('header-menu > details.mega-menu').forEach(function (details) {
      var timer;
      var parent = details.closest('li');
      if (!parent) return;
      parent.addEventListener('mouseenter', function () {
        if (!mqDesktop.matches) return;
        clearTimeout(timer);
        document.querySelectorAll('header-menu > details[open]').forEach(function (d) { if (d !== details) d.removeAttribute('open'); });
        details.setAttribute('open', '');
        details.querySelector('summary').setAttribute('aria-expanded', 'true');
      });
      var summary = details.querySelector('summary');
      if (summary && summary.dataset.href && summary.dataset.href !== '#') {
        summary.addEventListener('click', function (e) {
          if (!mqDesktop.matches) return;
          e.preventDefault(); e.stopPropagation();
          window.location.href = summary.dataset.href;
        }, true);
      }
      parent.addEventListener('mouseleave', function () {
        if (!mqDesktop.matches) return;
        timer = setTimeout(function () {
          details.removeAttribute('open');
          details.querySelector('summary').setAttribute('aria-expanded', 'false');
        }, 120);
      });
    });
  }

  /* 2. Tabs */
  function initTabs() {
    document.querySelectorAll('[data-refy-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[role=tab]');
      var panels = root.querySelectorAll('[role=tabpanel]');
      function activate(i) {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', i === j ? 'true' : 'false'); t.tabIndex = i === j ? 0 : -1; });
        panels.forEach(function (p, j) { if (i === j) p.setAttribute('data-active', ''); else p.removeAttribute('data-active'); });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(i); });
        t.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
          if (n === null) return;
          n = (n + tabs.length) % tabs.length; activate(n); tabs[n].focus(); e.preventDefault();
        });
      });
      activate(0);
    });
  }

  /* 3. Shade visualiser */
  function initVisualiser() {
    document.querySelectorAll('[data-refy-visualiser]').forEach(function (root) {
      var buttons = root.querySelectorAll('[data-shade]');
      var images = root.querySelectorAll('[data-shade-image]');
      var label = root.querySelector('[data-shade-label]');
      var cta = root.querySelector('[data-shade-cta]');
      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          var key = b.getAttribute('data-shade');
          buttons.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          images.forEach(function (img) { img.classList.toggle('is-active', img.getAttribute('data-shade-image') === key); });
          if (label) label.textContent = b.getAttribute('data-shade-name') || '';
          if (cta && b.getAttribute('data-shade-url')) cta.setAttribute('href', b.getAttribute('data-shade-url'));
        });
      });
    });
  }

  /* 4. Image swatches for Color/Shade options on the product form */
  function initSwatches() {
    document.querySelectorAll('[data-refy-swatch-map]').forEach(function (script) {
      var map; try { map = JSON.parse(script.textContent); } catch (e) { return; }
      var section = script.closest('.shopify-section') || document;
      section.querySelectorAll('fieldset.product-form__input').forEach(function (fs) {
        fs.dataset.refySeen = '1';
        if (fs.dataset.refySwatched) return;
        var legend = fs.querySelector('legend');
        var name = legend ? legend.textContent.trim().toLowerCase() : '';
        if (!/colou?r|shade|اللون|الدرجة/.test(name)) return;
        fs.dataset.refySwatched = '1';
        var inputs = fs.querySelectorAll('input[type=radio]');
        var hit = 0;
        inputs.forEach(function (input) {
          var url = map[input.value];
          var lab = fs.querySelector('label[for="' + input.id + '"]');
          if (!url || !lab) return;
          if (url.charAt(0) === '#') { lab.style.setProperty('--refy-sw', url); lab.style.backgroundImage = 'none'; lab.dataset.refyColor = url; lab.classList.add('refy-swatch--dot'); }
          else { lab.style.backgroundImage = 'url(' + url + ')'; lab.dataset.refyImage = url; }
          hit++;
        });
        if (!hit) return;
        fs.classList.add('refy-swatches');
        var nameEl = document.createElement('span');
        nameEl.className = 'refy-swatch-name';
        if (legend) { legend.appendChild(nameEl); legend.style.width = '100%'; }
        function sync() {
          var checked = fs.querySelector('input[type=radio]:checked');
          nameEl.textContent = checked ? checked.value : '';
        }
        fs.addEventListener('change', sync);
        inputs.forEach(function (input) {
          var lab = fs.querySelector('label[for="' + input.id + '"]');
          if (!lab) return;
          lab.addEventListener('mouseenter', function () { nameEl.textContent = input.value; });
          lab.addEventListener('mouseleave', sync);
        });
        sync();
      });
    });
  }

  /* 4a2. Bundle pickers start empty: a dropdown counts as chosen only after the customer picks (or the URL carries ?variant=) */
  var refyChosen = {};
  var refyPresetUrl = /[?&]variant=\d/.test(location.search) ? location.pathname : null;
  function refyDdName(fs) { var lg = fs.querySelector('legend'); return lg ? lg.childNodes[0].textContent.trim().replace(/\s*\(.*\)\s*$/, '').replace(/:\s*$/, '') : 'Shade'; }
  function refyDdKey(fs) { var pi = fs.closest('product-info'); return ((pi && pi.dataset.url) || location.pathname) + '|' + refyDdName(fs); }
  function refyIsChosen(fs) { var pi = fs.closest('product-info'); var url = (pi && pi.dataset.url) || location.pathname; return (refyPresetUrl && url.split('?')[0] === refyPresetUrl) || !!refyChosen[refyDdKey(fs)]; }
  function refyMissing(root) { var out = null; (root || document).querySelectorAll('fieldset.refy-swatches--dd').forEach(function (fs) { if (!out && !refyIsChosen(fs)) out = fs; }); return out; }
  function refyPrompt(fs) {
    var dd = fs.previousElementSibling; if (!dd || !dd.classList.contains('refy-dd')) return;
    dd.classList.add('is-error');
    var msg = dd.querySelector('.refy-dd__error'); if (!msg) { msg = document.createElement('p'); msg.className = 'refy-dd__error'; msg.setAttribute('role', 'alert'); dd.insertBefore(msg, dd.querySelector('.refy-dd__head')); }
    msg.textContent = rT('selectShadeFor', 'Please select a shade for ') + refyDdName(fs);
    var head = dd.querySelector('.refy-dd__head'), list = dd.querySelector('.refy-dd__list');
    if (list && list.hidden && head) head.click();
    dd.scrollIntoView && dd.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  function refyNeedsShadeLabel() {
    document.querySelectorAll('product-info').forEach(function (pi) {
      var b = pi.querySelector('.product-form__submit'); var span = b && b.querySelector('span'); if (!span) return;
      var dds = pi.querySelectorAll('fieldset.refy-swatches--dd').length; var missing = dds && refyMissing(pi);
      var want = missing && !b.disabled ? (dds > 1 ? rT('selectShades', 'Select shades') : rT('selectShade', 'Select shade')) : null;
      if (want && span.textContent.trim() !== want) { span.textContent = want; b.classList.add('refy-needs-shade'); }
      else if (!want && b.classList.contains('refy-needs-shade')) { b.classList.remove('refy-needs-shade'); if (!b.disabled && window.variantStrings && span.textContent.trim() !== window.variantStrings.addToCart) span.textContent = window.variantStrings.addToCart; }
    });
  }
  function refyGuard(e) {
    var t = e.target; if (!t || !t.closest) return;
    var form = e.type === 'submit' ? t : null;
    if (e.type === 'click') { if (!t.closest('.shopify-payment-button')) return; form = t.closest('form') || t.closest('product-form'); }
    if (!form || (e.type === 'submit' && !/\/cart\/add/.test(form.getAttribute('action') || ''))) return;
    var pi = form.closest('product-info'); if (!pi) return;
    var missing = refyMissing(pi); if (!missing) return;
    e.preventDefault(); e.stopImmediatePropagation(); refyPrompt(missing);
  }
  document.addEventListener('submit', refyGuard, true);
  document.addEventListener('click', refyGuard, true);

  /* 4b. Bundles (2+ options): REFY-style "Select shade" dropdown per option */
  function initBundlePicker() {
    document.querySelectorAll('variant-selects').forEach(function (vs) {
      var sets = vs.querySelectorAll('fieldset.refy-swatches');
      if (sets.length < 2 && !document.querySelector('[data-refy-shade-images]')) return;
      sets.forEach(function (fs) {
        if (fs.dataset.refyDd) return; fs.dataset.refyDd = '1';
        var legend = fs.querySelector('legend');
        var optName = legend ? legend.childNodes[0].textContent.trim().replace(/\s*\(.*\)\s*$/, '') : rT('shade', 'Shade');
        var dd = document.createElement('div'); dd.className = 'refy-dd';
        var head = document.createElement('button'); head.type = 'button'; head.className = 'refy-dd__head'; head.setAttribute('aria-expanded', 'false');
        var list = document.createElement('div'); list.className = 'refy-dd__list'; list.hidden = true;
        var title = document.createElement('p'); title.className = 'refy-dd__title'; title.textContent = optName;
        function paint() {
          var checked = fs.querySelector('input[type=radio]:checked'); if (checked && !refyIsChosen(fs)) checked = null;
          head.innerHTML = '<span class="refy-dd__label">' + (checked ? '<span class="refy-dd__mini" style="' + (checked.dataset.refyStyle || '') + '"></span>' + checked.value : rT('selectShade', 'Select shade')) + '</span><svg viewBox="0 0 12 8" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M1 1l5 5 5-5"/></svg>';
          list.querySelectorAll('.refy-dd__item').forEach(function (it) { it.setAttribute('aria-selected', checked && it.dataset.value === checked.value ? 'true' : 'false'); });
        }
        fs.querySelectorAll('input[type=radio]').forEach(function (input) {
          var lab = fs.querySelector('label[for="' + input.id + '"]');
          var style = lab && lab.dataset.refyColor ? 'background-color:' + lab.dataset.refyColor : (lab && lab.dataset.refyImage ? 'background-image:url(' + lab.dataset.refyImage + ')' : '');
          input.dataset.refyStyle = style;
          var it = document.createElement('button'); it.type = 'button'; it.className = 'refy-dd__item'; it.dataset.value = input.value;
          it.innerHTML = '<span class="refy-dd__swatch" style="' + style + '"></span><span class="refy-dd__name">' + input.value + '</span>';
          if (input.disabled || input.classList.contains('disabled') || (lab && lab.classList.contains('disabled'))) it.classList.add('is-unavailable');
          it.addEventListener('click', function () { var was = refyIsChosen(fs); refyChosen[refyDdKey(fs)] = true; dd.classList.remove('is-error'); var er = dd.querySelector('.refy-dd__error'); if (er) er.remove(); if (!input.checked || !was) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); } list.hidden = true; head.setAttribute('aria-expanded', 'false'); paint(); refyNeedsShadeLabel(); });
          list.appendChild(it);
        });
        head.addEventListener('click', function () { var open = list.hidden; document.querySelectorAll('.refy-dd__list').forEach(function (l) { l.hidden = true; }); document.querySelectorAll('.refy-dd__head').forEach(function (h) { h.setAttribute('aria-expanded', 'false'); }); list.hidden = !open; head.setAttribute('aria-expanded', open ? 'true' : 'false'); });
        dd.appendChild(title); dd.appendChild(head); dd.appendChild(list);
        if (!fs.isConnected || !fs.parentNode) { delete fs.dataset.refyDd; return; }
        fs.classList.add('refy-swatches--dd'); try { fs.parentNode.insertBefore(dd, fs); } catch (err) { delete fs.dataset.refyDd; return; }
        paint();
      });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.refy-dd')) document.querySelectorAll('.refy-dd__list').forEach(function (l) { l.hidden = true; }); });
  }

  /* 4d. Bundle shade preview: chosen shade -> gallery shows that component's shade photo + "Your set" strip */
  function initShadePreview() {
    var src = document.querySelector('[data-refy-shade-images]'); if (!src || src.dataset.refyReady) return;
    var map; try { map = JSON.parse(src.textContent); } catch (e) { return; }
    var keys = Object.keys(map); if (!keys.length) return;
    src.dataset.refyReady = '1';
    var gallery = document.querySelector('media-gallery'), list = gallery && gallery.querySelector('.product__media-list');
    var vs = document.querySelector('variant-selects'); if (!vs) return;
    var strip = document.querySelector('[data-refy-set]');
    if (!strip) { strip = document.createElement('div'); strip.className = 'refy-set'; strip.setAttribute('data-refy-set', ''); strip.innerHTML = '<p class="refy-set__title">' + rT('yourSet', 'Your set') + '</p><div class="refy-set__tiles"></div>'; vs.parentNode.insertBefore(strip, vs.nextSibling); }
    var tiles = strip.querySelector('.refy-set__tiles'), slides = {};
    keys.forEach(function (k, n) {
      var tile = Array.prototype.find.call(tiles.querySelectorAll('.refy-set__tile'), function (t) { return (t.dataset.product || '').toLowerCase() === map[k].product.toLowerCase(); });
      if (!tile) { tile = document.createElement('div'); tile.className = 'refy-set__tile'; tile.innerHTML = '<span class="refy-set__media"><img alt="" loading="lazy"></span><span class="refy-set__name">' + map[k].product + '</span><span class="refy-set__shade">' + rT('chooseShade', 'Choose a shade') + '</span>'; tiles.appendChild(tile); }
      tile.dataset.opt = k;
      if (list) {
        var li = document.createElement('li'); li.className = 'product__media-item grid__item slider__slide refy-shade-slide'; li.dataset.mediaId = 'refy-shade-' + n; li.hidden = true;
        li.innerHTML = '<div class="product-media-container media-type-image media-fit-cover global-media-settings gradient constrain-height"><div class="product__media media media--transparent"><img class="refy-hero-img" alt=""></div></div>';
        list.appendChild(li); slides[k] = li;
      }
    });
    function optOf(fs) { var lg = fs.querySelector('legend'); var txt = lg ? lg.textContent.trim() : ''; return keys.find(function (k) { return txt.indexOf(k) === 0; }) || keys.find(function (k) { return txt.indexOf(k.split(' (')[0]) === 0; }); }
    function show(k, val, activate) {
      var e = map[k], sh = e.shades[val], img = sh ? sh.img : e.fallback, alt = sh ? sh.alt : e.product;
      var tile = Array.prototype.find.call(tiles.querySelectorAll('.refy-set__tile'), function (t) { return t.dataset.opt === k; });
      if (tile) { var ti = tile.querySelector('img'); if (ti) ti.src = img; tile.querySelector('.refy-set__shade').textContent = val || rT('chooseShade', 'Choose a shade'); tile.classList.toggle('is-set', !!val); }
      var li = slides[k];
      if (li && img) { var im = li.querySelector('img'); im.src = img; im.alt = alt; li.hidden = false;
        if (activate && gallery) { gallery.querySelectorAll('.product__media-item').forEach(function (x) { x.classList.remove('is-active'); }); li.classList.add('is-active'); li.scrollIntoView && window.innerWidth < 750 && li.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }
      }
    }
    function sync(activateKey) {
      document.querySelectorAll('variant-selects fieldset').forEach(function (fs) {
        var k = optOf(fs); if (!k) return; var c = fs.querySelector('input[type=radio]:checked'); if (c && !refyIsChosen(fs)) c = null; show(k, c ? c.value : '', activateKey === k);
      });
    }
    document.addEventListener('change', function (e) { var fs = e.target.closest && e.target.closest('variant-selects fieldset'); if (!fs || e.target.type !== 'radio') return; var k = optOf(fs); setTimeout(function () { sync(k); }, 60); });
    sync(null);
    strip.addEventListener('click', function (e) { var tile = e.target.closest('.refy-set__tile'); if (!tile) return; var k = tile.dataset.opt; var c = null; document.querySelectorAll('variant-selects fieldset').forEach(function (fs) { if (optOf(fs) === k) { c = fs.querySelector('input[type=radio]:checked'); if (c && !refyIsChosen(fs)) c = null; } }); show(k, c ? c.value : '', true); });
  }

  /* 4c. Bundle & Save / Pair it with tabs */
  function initPairTabs() {
    document.querySelectorAll('[data-refy-pair]').forEach(function (root) {
      if (root.dataset.refyReady) return; root.dataset.refyReady = '1';
      var tabs = root.querySelectorAll('[data-pair-tab]'), panels = root.querySelectorAll('[data-pair-panel]');
      tabs.forEach(function (t) { t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        panels.forEach(function (p) { p.hidden = p.dataset.pairPanel !== t.dataset.pairTab; });
      }); });
    });
  }

  /* 5. Hero video mute toggle */
  function initHeroMute() {
    document.querySelectorAll('[data-refy-mute]').forEach(function (btn) {
      var root = btn.closest('.refy-hero');
      btn.addEventListener('click', function () {
        var muted;
        root.querySelectorAll('video').forEach(function (v) { v.muted = !v.muted; muted = v.muted; });
        btn.setAttribute('aria-pressed', muted ? 'false' : 'true');
        btn.classList.toggle('is-unmuted', !muted);
      });
    });
  }

  /* 6. Footer accordions: open on desktop, collapsible on mobile */
  function initFooter() {
    var cols = document.querySelectorAll('details.refy-footer__column--mobile');
    function apply() { cols.forEach(function (d) { if (mqDesktop.matches) d.setAttribute('open', ''); }); }
    apply(); mqDesktop.addEventListener('change', apply);
  }

  /* 7. Arrow carousels */
  function initCarousels() {
    document.querySelectorAll('[data-refy-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-refy-track]'); if (!track) return;
      var prev = root.querySelector('[data-refy-prev]'), next = root.querySelector('[data-refy-next]');
      function step() { var first = track.firstElementChild; return first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : 300; }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.hidden = track.scrollLeft <= 2;
        if (next) next.hidden = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
    });
    document.querySelectorAll('[data-refy-mute-one]').forEach(function (btn) {
      btn.addEventListener('click', function () { var v = btn.parentElement.querySelector('video'); if (!v) return; v.muted = !v.muted; btn.classList.toggle('is-unmuted', !v.muted); });
    });
  }

  /* 7b. Mobile swipe cue: thin progress line under every horizontal carousel */
  function initSwipeHint() {
    var tracks = document.querySelectorAll('slider-component .slider, [data-refy-track]');
    tracks.forEach(function (track) {
      if (track.dataset.refyHint) return; track.dataset.refyHint = '1';
      var host = track.closest('slider-component') || track.closest('[data-refy-carousel]') || track.parentElement;
      var bar = document.createElement('div'); bar.className = 'refy-progress'; bar.innerHTML = '<i></i>';
      host.parentNode.insertBefore(bar, host.nextSibling);
      var fill = bar.firstElementChild;
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 4) { bar.hidden = true; return; }
        bar.hidden = false;
        var size = Math.max(track.clientWidth / track.scrollWidth * 100, 12);
        var pos = track.scrollLeft / max * (100 - size);
        fill.style.width = size + '%'; fill.style.left = pos + '%';
      }
      track.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
      setTimeout(update, 600);
    });
  }

  /* 7c. Hero videos: attach a source only to the visible twin (desktop or mobile); HLS on Safari */
  // Shopify Liquid only exposes the top (1080p) mp4, so small cards stream HLS instead and cap the rendition:
  // Safari (native HLS) sizes renditions to the element; other browsers get hls.js with autoLevelCapping.
  var refyHlsLib = null;
  function refyLoadHls() {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (refyHlsLib) return refyHlsLib;
    refyHlsLib = new Promise(function (res, rej) { var s = document.createElement('script'); s.src = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.15/dist/hls.light.min.js'; s.onload = function () { res(window.Hls); }; s.onerror = rej; document.head.appendChild(s); });
    return refyHlsLib;
  }
  function initLazyVideo() {
    var vids = document.querySelectorAll('video[data-refy-src]');
    var play = function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    var attachStream = function (v) {
      var hls = v.dataset.refyHls, maxH = parseInt(v.dataset.refyMaxH || '1080', 10);
      if (hls && v.canPlayType('application/vnd.apple.mpegurl')) { v.src = hls; v.load(); play(v); return; }
      if (hls && maxH < 1080 && window.MediaSource) {
        refyLoadHls().then(function (Hls) {
          if (!Hls || !Hls.isSupported()) { v.src = v.dataset.refySrc; v.load(); play(v); return; }
          var h = new Hls({ autoStartLoad: false, startLevel: 0, capLevelToPlayerSize: true, ignoreDevicePixelRatio: true, maxBufferLength: 8, maxMaxBufferLength: 12 });
          h.on(Hls.Events.MANIFEST_PARSED, function (e, data) {
            var cap = -1; data.levels.forEach(function (l, i) { if (l.height <= maxH) cap = i; });
            if (cap >= 0) { h.autoLevelCapping = cap; h.nextLevel = cap; }
            h.startLoad(0); play(v);
          });
          h.loadSource(hls); h.attachMedia(v); v.refyHls = h;
        }).catch(function () { v.src = v.dataset.refySrc; v.load(); play(v); });
        return;
      }
      v.src = v.dataset.refySrc; v.load(); play(v);
    };
    var attach = function (v) {
      if (v.dataset.refyLoaded || !v.getClientRects().length) return;
      v.dataset.refyLoaded = '1';
      // hero: start the stream only after the page `load` event + an idle slot (the poster stays on screen meanwhile)
      if (v.closest('.refy-hero') && !v.dataset.refyIdle) {
        v.dataset.refyIdle = '1';
        var go = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 1); })(function () { delete v.dataset.refyLoaded; attach(v); }, { timeout: 2000 }); };
        if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
        return;
      }
      if (v.classList.contains('refy-video--posterless')) v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
      var lite = v.dataset.refyLite;
      if (!lite) { attachStream(v); return; }
      // prefer the small hand-encoded copy when it exists (HEAD is cheap); otherwise stream
      fetch(lite, { method: 'HEAD' }).then(function (r) { if (r.ok) { v.src = lite; v.load(); play(v); } else attachStream(v); }).catch(function () { attachStream(v); });
    };
    if (!('IntersectionObserver' in window)) { vids.forEach(attach); return; }
    if (!window.refyVidIO) {
      window.refyVidIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { attach(e.target); if (e.target.paused && e.target.dataset.refyLoaded) play(e.target); }
          else if (e.target.dataset.refyLoaded && !e.target.paused) e.target.pause();
        });
      }, { rootMargin: '300px 0px', threshold: 0.05 });
    }
    vids.forEach(function (v) { if (!v.dataset.refyObserved) { v.dataset.refyObserved = '1'; window.refyVidIO.observe(v); } });
  }
  var refyVidTimer; window.addEventListener('resize', function () { clearTimeout(refyVidTimer); refyVidTimer = setTimeout(initLazyVideo, 200); });

  /* 7d. Creator dashboard: copy code, show product pickers only for that topic */
  function initCreator() {
    document.querySelectorAll('[data-refy-copy]').forEach(function (btn) {
      if (btn.dataset.refyReady) return; btn.dataset.refyReady = '1';
      btn.addEventListener('click', function () {
        var src = btn.parentElement.querySelector('[data-refy-copy-src]'); if (!src) return;
        var txt = src.textContent.trim(), done = function () { var o = btn.textContent; btn.textContent = rT('copied', 'Copied'); setTimeout(function () { btn.textContent = o; }, 1500); };
        if (navigator.clipboard) navigator.clipboard.writeText(txt).then(done); else { var r = document.createRange(); r.selectNodeContents(src); var s = getSelection(); s.removeAllRanges(); s.addRange(r); document.execCommand('copy'); done(); }
      });
    });
    var topic = document.getElementById('CU-topic');
    if (topic && !topic.dataset.refyReady) {
      topic.dataset.refyReady = '1';
      var sync = function () { document.querySelectorAll('[data-refy-topic]').forEach(function (el) { el.classList.toggle('is-on', el.dataset.refyTopic === topic.value); }); };
      topic.addEventListener('change', sync); sync();
    }
  }

  /* 7e. PDP review rotator: auto-advances every 5s, dots, swipe, pauses on hover */
  // Rich-text metafields often carry stray <br> around list items, which pushes the number onto its own line. Tidy them.
  function initTidyLists() {
    document.querySelectorAll('[data-refy-tidy] li').forEach(function (li) {
      var isBlank = function (n) { return n && ((n.nodeType === 3 && !n.textContent.trim()) || (n.nodeType === 1 && n.tagName === 'BR')); };
      while (isBlank(li.firstChild)) li.removeChild(li.firstChild);
      while (isBlank(li.lastChild)) li.removeChild(li.lastChild);
      li.querySelectorAll('br').forEach(function (br) {
        var n = br.previousSibling; while (n && n.nodeType === 3 && !n.textContent.trim()) n = n.previousSibling;
        if (n && n.nodeType === 1 && n.tagName === 'BR') br.remove();
      });
    });
  }
  // Community / lifestyle videos: kick playback when visible (browsers often skip autoplay for lazily-loaded video)
  function initAutoplayVideos() {
    var vids = document.querySelectorAll('[data-refy-autoplay] video');
    if (!vids.length) return;
    var tryPlay = function (v) { v.muted = true; v.playsInline = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); };
    if (!('IntersectionObserver' in window)) { vids.forEach(tryPlay); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) tryPlay(e.target); else if (!e.target.paused && e.target.muted) e.target.pause(); });
    }, { rootMargin: '200px 0px', threshold: 0.1 });
    vids.forEach(function (v) { io.observe(v); });
  }
  function initReviews() {
    document.querySelectorAll('[data-refy-reviews]').forEach(function (root) {
      if (root.dataset.refyReady) return; root.dataset.refyReady = '1';
      var items = root.querySelectorAll('.refy-pdp__review'), dots = root.querySelectorAll('[data-refy-review-dot]'), i = 0, timer;
      if (items.length < 2) return;
      function show(n) { i = (n + items.length) % items.length; items.forEach(function (el, k) { el.classList.toggle('is-active', k === i); }); dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); }); }
      function start() { stop(); timer = setInterval(function () { show(i + 1); }, 5000); }
      function stop() { clearInterval(timer); }
      dots.forEach(function (d) { d.addEventListener('click', function () { show(+d.dataset.refyReviewDot); start(); }); });
      root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
      var x0 = null; root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) { show(dx < 0 ? i + 1 : i - 1); start(); } }, { passive: true });
      start();
    });
  }

  /* 7f. Free gift: add the gift line when the cart passes the threshold, remove it when it drops below */
  var refyGiftBusy = false;
  function refyGiftSync() {
    var bar = document.querySelector('[data-refy-gift-bar]'); if (!bar || refyGiftBusy) return;
    var variant = bar.dataset.giftVariant, min = +bar.dataset.giftMin, qualifying = +bar.dataset.giftQualifying, inCart = bar.dataset.giftInCart === 'true';
    var want = qualifying >= min && qualifying > 0 && bar.dataset.giftSkip !== 'true';
    if (want === inCart) return;
    refyGiftBusy = true;
    var drawer = document.querySelector('cart-drawer');
    var sections = 'cart-drawer,cart-icon-bubble';
    var req;
    if (want) {
      req = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +variant, quantity: 1, properties: { _gift: 'free' } }], sections: sections }) });
    } else {
      req = fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var line = cart.items.find(function (it) { return String(it.variant_id) === String(variant) && (bar.dataset.giftSkip !== 'true' || (it.properties && it.properties._gift)); });
        if (!line) return null;
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0, sections: sections }) });
      });
    }
    req.then(function (r) { return r ? r.json() : null; }).then(function (res) {
      if (res && res.sections && drawer && drawer.renderContents) {
        var open = drawer.classList.contains('active');
        drawer.renderContents(res);
        if (!open) setTimeout(function () { drawer.close && drawer.close(); }, 0);
      }
    }).catch(function () {}).finally(function () { refyGiftBusy = false; });
  }

  /* 8. PDP gallery: counter, round arrows, caption from alt */
  function initGallery() {
    document.querySelectorAll('media-gallery').forEach(function (g) {
      if (g.dataset.refyReady) return; g.dataset.refyReady = '1';
      var items = Array.prototype.slice.call(g.querySelectorAll('.product__media-item[data-media-id]'));
      if (items.length < 1) return;
      var counter = document.createElement('span'); counter.className = 'refy-gallery__counter';
      var cap = document.createElement('span'); cap.className = 'refy-gallery__caption';
      var prev = document.createElement('button'); prev.type = 'button'; prev.className = 'refy-gallery__arrow refy-gallery__arrow--prev'; prev.setAttribute('aria-label', rT('previous', 'Previous')); prev.innerHTML = '<svg viewBox="0 0 10 16" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M8 1L2 8l6 7"/></svg>';
      var next = prev.cloneNode(true); next.className = 'refy-gallery__arrow refy-gallery__arrow--next'; next.setAttribute('aria-label', rT('next', 'Next')); next.innerHTML = '<svg viewBox="0 0 10 16" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M2 1l6 7-6 7"/></svg>';
      g.appendChild(counter); g.appendChild(cap); if (items.length > 1) { g.appendChild(prev); g.appendChild(next); }
      function idx() { var fresh = Array.prototype.slice.call(g.querySelectorAll('.product__media-item[data-media-id]')); if (fresh.length) items = fresh; var i = items.findIndex(function (x) { return x.classList.contains('is-active'); }); return i < 0 ? 0 : i; }
      function paint() { var i = idx(); counter.textContent = (i + 1) + '/' + items.length; var img = items[i].querySelector('img'); cap.textContent = img && img.alt && img.alt.indexOf('http') < 0 ? img.alt.replace(/^\s*SHADEIMG::\s*/, '').replace(/#hide/g, '').trim() : ''; }
      function go(d) { var i = (idx() + d + items.length) % items.length; if (typeof g.setActiveMedia === 'function') { try { g.setActiveMedia(items[i].dataset.mediaId, false); } catch (err) { /* hero/hover slides have no thumbnail; Dawn throws after activating */ } } else { items.forEach(function (x, k) { x.classList.toggle('is-active', k === i); }); } paint(); }
      prev.addEventListener('click', function () { go(-1); }); next.addEventListener('click', function () { go(1); });
      new MutationObserver(paint).observe(g, { attributes: true, subtree: true, attributeFilter: ['class'] });
      paint();
    });
  }

  /* 9. Move quick-add bar into the card media box so it overlays the image bottom (REFY) */
  function initQuickAdd() {
    document.querySelectorAll('.card-wrapper .quick-add').forEach(function (qa) {
      if (qa.dataset.refyMoved) return;
      var inner = qa.closest('.card-wrapper').querySelector('.card__inner');
      if (!inner) return;
      inner.appendChild(qa); qa.dataset.refyMoved = '1';
    });
  }

  /* 10. Sticky add-to-cart bar (shows once the buy box scrolls out) */
  function initSticky() {
    var bar = document.querySelector('[data-refy-sticky]'); if (!bar || bar.dataset.refyReady) return;
    var submit = document.querySelector('.product-form__submit'); if (!submit) return;
    bar.dataset.refyReady = '1';
    var add = bar.querySelector('[data-sticky-add]');
    add.addEventListener('click', function () { var b = document.querySelector('.product-form__submit'); if (b && !b.disabled) b.click(); });
    function sync() {
      var b = document.querySelector('.product-form__submit');
      var checked = document.querySelector('fieldset.product-form__input input[type=radio]:checked');
      var pi0 = b && b.closest('product-info'); var miss = pi0 ? refyMissing(pi0) : null;
      var v = bar.querySelector('[data-sticky-variant]'); if (v) v.textContent = checked && !miss ? ' - ' + checked.value : '';
      var pr = document.querySelector('.refy-pricerow .refy-price'); var p = bar.querySelector('[data-sticky-price]'); if (pr && p) p.textContent = pr.childNodes[0] ? pr.childNodes[0].textContent.trim() : pr.textContent.trim();
      if (b) { add.disabled = b.disabled; add.querySelector('span').textContent = b.disabled || miss ? b.textContent.trim() : add.dataset.label || add.querySelector('span').textContent; }
    }
    add.dataset.label = add.querySelector('span').textContent;
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { var below = e.boundingClientRect.top < 0; bar.hidden = e.isIntersecting || !below; }); }, { threshold: 0 });
    io.observe(submit);
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) setTimeout(sync, 1500); });
    new MutationObserver(function () { var s2 = document.querySelector('.product-form__submit'); if (s2 && s2 !== submit) { io.unobserve(submit); submit = s2; io.observe(submit); } sync(); }).observe(document.querySelector('.product__info-wrapper') || document.body, { childList: true, subtree: true });
    sync();
  }

  function init() { initTidyLists(); initAutoplayVideos(); initShadePreview(); refyGiftSync(); initReviews(); initCreator(); initLazyVideo(); initSticky(); initQuickAdd(); initGallery(); initCarousels(); initSwipeHint(); initMegaHover(); initTabs(); initVisualiser(); initSwatches(); initBundlePicker(); refyNeedsShadeLabel(); initPairTabs(); initHeroMute(); initFooter(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initTidyLists(); initAutoplayVideos(); initReviews(); initCreator(); initLazyVideo(); initQuickAdd(); initGallery(); initCarousels(); initSwipeHint(); initTabs(); initVisualiser(); initSwatches(); initHeroMute(); initFooter(); });
  var refyBusy = false;
  function refySyncStock() {
    var b = document.querySelector('.product-form__submit'); var st = document.querySelector('.refy-stock'); if (!b || !st) return;
    var sold = b.disabled; var txt = st.textContent.trim().toLowerCase();
    if (sold && !st.classList.contains('refy-stock--out')) { st.textContent = rT('soldOut', 'Sold out'); st.classList.add('refy-stock--out'); }
    else if (!sold && st.classList.contains('refy-stock--out')) { st.textContent = rT('inStock', 'In stock'); st.classList.remove('refy-stock--out'); }
  }
  function refyRedecorate() {
    refySyncStock(); refyGiftSync();
    if (refyBusy) return;
    refyBusy = true;
    try { initShadePreview(); initReviews(); initQuickAdd(); initSwatches(); initBundlePicker(); refyNeedsShadeLabel(); initGallery(); initPairTabs(); } finally { refyBusy = false; }
  }
  new MutationObserver(function (m) {
    if (refyBusy) return;
    for (var i = 0; i < m.length; i++) {
      var t = m[i].target;
      if (t && t.closest && (t.closest('product-info, variant-selects, .product__info-wrapper, .product-form__input, .card-wrapper, media-gallery, cart-drawer, .collection, .related-products'))) { refyRedecorate(); return; }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
